var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bairun-container" },
    [
      _c("SearchTerm", {
        attrs: {
          "search-info": _vm.searchInfo,
          "search-more": false,
          "search-base-items": [],
          btns: { search: true, reset: true }
        },
        on: { onChange: function() {} }
      }),
      _c("el-pagination", {
        style: { float: "right", padding: "20px" },
        attrs: {
          small: "",
          "current-page": _vm.page,
          "page-size": _vm.pageSize,
          "page-sizes": [10],
          total: _vm.total,
          layout: "total, sizes, prev, pager, next, jumper"
        },
        on: {
          "current-change": _vm.handleCurrentChange,
          "size-change": _vm.handleSizeChange
        }
      }),
      _c(
        "div",
        { staticClass: "bairun-table-btns" },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.openDialog } },
            [_vm._v("新增")]
          ),
          _c(
            "el-button",
            { attrs: { type: "danger" }, on: { click: _vm.onBattchDelete } },
            [_vm._v("批量删除")]
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          ref: "multipleTable",
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            border: "",
            stripe: "",
            height: "45rem",
            "tooltip-effect": "dark"
          },
          on: { "selection-change": _vm.handleSelectionChange }
        },
        [
          _c("el-table-column", { attrs: { type: "selection", width: "50" } }),
          _c("el-table-column", {
            attrs: { label: "群编号", prop: "groupId", width: "150" }
          }),
          _c("el-table-column", {
            attrs: { label: "群名称", prop: "groupName" }
          }),
          _c("el-table-column", {
            attrs: {
              label: "收银端是否可操作",
              prop: "isCashierShow",
              width: "150"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.isCashierShow == 1
                      ? _c("el-link", { attrs: { type: "primary" } }, [
                          _vm._v("是")
                        ])
                      : _c("el-link", { attrs: { type: "danger" } }, [
                          _vm._v("否")
                        ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "收银端可操作的油站", prop: "cashierShowStations" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.cashierShowStations == "-1"
                      ? _c("span", [_c("span", [_vm._v("所有油站")])])
                      : scope.row.cashierShowStations.split(",")[0] != ""
                      ? _c(
                          "span",
                          [
                            _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: {
                                  effect: "dark",
                                  placement: "top-start"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    attrs: { slot: "content" },
                                    slot: "content"
                                  },
                                  _vm._l(
                                    scope.row.cashierShowStations.split(","),
                                    function(item, index) {
                                      return _c("span", { key: index }, [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.allStationMap[String(item)]
                                                .stationName
                                            )
                                        ),
                                        _c("br")
                                      ])
                                    }
                                  ),
                                  0
                                ),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      parseInt(
                                        scope.row.cashierShowStations.split(
                                          ","
                                        )[0]
                                      )
                                    ) +
                                    " "
                                ),
                                scope.row.cashierShowStations.split(",")
                                  .length > 1
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.allStationMap[
                                            scope.row.cashierShowStations.split(
                                              ","
                                            )[0]
                                          ].stationName
                                        ) + " ···"
                                      )
                                    ])
                                  : _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.allStationMap[
                                            scope.row.cashierShowStations.split(
                                              ","
                                            )[0]
                                          ].stationName
                                        )
                                      )
                                    ])
                              ]
                            )
                          ],
                          1
                        )
                      : _c("span")
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "最后操作人", prop: "sysUserName", width: "150" }
          }),
          _c("el-table-column", {
            attrs: { label: "更新时间", prop: "UpdatedAt", width: "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(_vm._s(_vm._f("formatDate")(scope.row.UpdatedAt)))
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "创建时间", prop: "CreatedAt", width: "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(_vm._s(_vm._f("formatDate")(scope.row.CreatedAt)))
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "操作区", width: "120" },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function(scope) {
                    return scope.row.groupId > 0
                      ? [
                          _c(
                            "el-dropdown",
                            { attrs: { trigger: "click" } },
                            [
                              _c("el-button", [
                                _vm._v("更多"),
                                _c("i", {
                                  staticClass:
                                    "el-icon-arrow-down el-icon--right"
                                })
                              ]),
                              _c(
                                "el-dropdown-menu",
                                {
                                  attrs: { slot: "dropdown" },
                                  slot: "dropdown"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.updateSvcGroup(scope.row)
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "el-dropdown-item",
                                        { attrs: { icon: "el-icon-edit" } },
                                        [_vm._v("编辑")]
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.deleteRow(scope.row)
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "el-dropdown-item",
                                        { attrs: { icon: "el-icon-delete" } },
                                        [_vm._v("删除")]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      : undefined
                  }
                }
              ],
              null,
              true
            )
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.closeDialog,
            visible: _vm.dialogFormVisible,
            title: _vm.dialogTitle
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogFormVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "formData",
              attrs: {
                model: _vm.formData,
                rules: _vm.rules,
                "label-position": "right"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "油站:", prop: "sellerId" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder: "请选择"
                      },
                      on: { change: _vm.onSelectStationChange },
                      model: {
                        value: _vm.formData.sellerId,
                        callback: function($$v) {
                          _vm.$set(_vm.formData, "sellerId", $$v)
                        },
                        expression: "formData.sellerId"
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "所有油站", value: 0 }
                      }),
                      _vm._l(_vm.allStations, function(item) {
                        return _c("el-option", {
                          key: item.ID,
                          attrs: { label: item.stationName, value: item.ID }
                        })
                      })
                    ],
                    2
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "群名称:", prop: "groupName" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入" },
                    model: {
                      value: _vm.formData.groupName,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "groupName", $$v)
                      },
                      expression: "formData.groupName"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "收银端是否可选:" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { size: "small" },
                      model: {
                        value: _vm.formData.isCashierShow,
                        callback: function($$v) {
                          _vm.$set(_vm.formData, "isCashierShow", $$v)
                        },
                        expression: "formData.isCashierShow"
                      }
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("是")]),
                      _c("el-radio", { attrs: { label: 2 } }, [_vm._v("否")])
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "收银端可选油站:" } },
                [
                  _c(
                    "el-checkbox",
                    {
                      attrs: { disabled: _vm.formData.isCashierShow == 2 },
                      on: { change: _vm.handleStationCheckAllChange },
                      model: {
                        value: _vm.stationCheckAll,
                        callback: function($$v) {
                          _vm.stationCheckAll = $$v
                        },
                        expression: "stationCheckAll"
                      }
                    },
                    [_vm._v("全选")]
                  ),
                  _c(
                    "el-checkbox-group",
                    {
                      attrs: { disabled: _vm.formData.isCashierShow == 2 },
                      on: { change: _vm.handleCheckedStationChange },
                      model: {
                        value: _vm.stationIdChecked,
                        callback: function($$v) {
                          _vm.stationIdChecked = $$v
                        },
                        expression: "stationIdChecked"
                      }
                    },
                    _vm._l(_vm.allStations, function(item) {
                      return _c(
                        "el-checkbox",
                        { key: item.ID, attrs: { label: item.ID } },
                        [_vm._v(_vm._s(item.stationName))]
                      )
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "详情描述:" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入" },
                    model: {
                      value: _vm.formData.remark,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "remark", $$v)
                      },
                      expression: "formData.remark"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v("取 消")
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.enterDialog } },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }